/** @format */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import domesticTariffServices from "../../Services/domesticTariffServices";
import { ChangeStatus } from "../../Components";
import ReactPaginate from "react-paginate";
import Loader from "../../Components/Loader";
import { MdEdit } from "react-icons/md";

let currentPage1 = 1
export const DomesticTariffList = () => {
  const [domesticTariffList, setDomesticTariffList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const history = useHistory();

  useEffect(() => {
    getDomesticTariffList();
  }, [currentPage]);

  const getDomesticTariffList = () => {
    let param = { ...pagination, page: currentPage };
    domesticTariffServices.get_domestic_tariff(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setDomesticTariffList(res.data);
        setPagination(res.pagination);
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      domestic_tariff_id: isModalOpen._id,
      domestic_tariff_status:
        isModalOpen.domestic_tariff_status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    domesticTariffServices
      .update_domestic_tariff_status(postData)
      .then((res) => {
        if (res.status) {
          setIsModalOpen(false);
          getDomesticTariffList();
        }
      });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div>
                {/* <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                /> */}
              </div>
              <button
                className="btn btn-primary w-sm waves-effect waves-light"
                onClick={() => history.push("/add-domestic-tariff")}
              >
                Add Domestic Tariff
              </button>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Country</th>
                    <th>Origin city</th>
                    <th>Destination city</th>
                    <th>
                      Minimum
                      <br /> Up to KG
                    </th>
                    <th>
                      {" "}
                      Up to 5<br /> Kg amount
                    </th>
                    <th>
                      Every Additional
                      <br />
                      /KG amount
                    </th>
                    <th>
                      Maximum <br />
                      Up to amount
                    </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {domesticTariffList.length > 0 &&
                    domesticTariffList.map((item, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>{item.domestic_tariff_country_name}</td>
                        <td>{item.domestic_tariff_origin_city_name}</td>
                        <td>{item.domestic_tariff_destination_city_name}</td>
                        <td>{item.domestic_tariff_minimum_upto_count}</td>
                        <td>{item.domestic_tariff_minimum_upto_amount}</td>
                        <td>{item.domestic_tariff_every_additional_amount}</td>
                        <td>{item.domestic_tariff_maximum_amount}</td>
                        <td>
                          <span
                            className={
                              "badge rounded-pill font-size-12 pointer" +
                              (item.domestic_tariff_status === "ACTIVE"
                                ? " bg-success"
                                : " bg-soft-danger")
                            }
                            onClick={() => setIsModalOpen(item)}
                          >
                            {item.domestic_tariff_status}
                          </span>
                        </td>
                        <td>
                          {/* Button trigger modal */}
                          <MdEdit
                            className="pointer"
                            onClick={() =>
                              history.push(
                                "/edit-domestic-tariff?id=" + item._id,
                                item
                              )
                            }
                            color="#0323fe"
                            size="25px"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {domesticTariffList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {domesticTariffList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${
              isModalOpen.domestic_tariff_status === "ACTIVE"
                ? "Inactive"
                : "Active"
            } status?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
